const SortingTypes = {
    ASC: 'ASC',
    DESC: 'DESC',
    DISABLED: 'DISABLED',
};

export default SortingTypes;
